<template>
  <div class="netPage fixed_horizo_center">
    <van-form ref="form">
      <van-cell required title="链接地址">
        <template #default>
          <van-field
            v-model="addForm.url"
            name="linkAdd"
            type="text"
            maxlength="128"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入链接地址' }]"
          />
        </template>
      </van-cell>
      <van-cell required title="网页标题">
        <template #default>
          <van-field
            v-model="addForm.title"
            name="linkTitle"
            type="text"
            maxlength="30"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入网页标题' }]"
          />
        </template>
      </van-cell>
      <van-cell title="描述">
        <template #default>
          <van-field type="textarea" v-model="addForm.content" name="description" autosize="" rows="2" placeholder="请输入..." maxlength="128" show-word-limit />
          <dl class="border-bottom"></dl>
          <div class="form-upload">
            <img-file :size="Imgsize" @uploadImg="welcomeImg"></img-file>
            <div v-if="!addForm.picUrl" class="updataimgs">
              <van-icon name="plus" />
              <span class="center-text">上传封面图</span>
            </div>
            <img v-if="addForm.picUrl" class="upload-back-img" :src="addForm.picUrl" alt="" />
          </div>
          <div class="imgtext">仅支持jpg，png文件，且不超过10M，建议尺寸：160x160px</div>
        </template>
      </van-cell>
    </van-form>
    <div class="fixed_bottom fixed_horizo_center">
      <div class="button_bottom">
        <dl @click="resetUser">取消</dl>
        <dl @click="ensureComfirm" ref="ensureConfirm" :style="{ opacity: addForm.url && addForm.title ? 1 : 0.5 }">确认</dl>
      </div>
    </div>
  </div>
</template>

<script>
// import { wxConfig } from "../fastReply/js/config";
import imgFile from "@/views/wegroupsend/imgFile";
export default {
  name: "netPage",
  components: { imgFile },
  props: ["isEdit", "index", "ruleForm", "showPage"],
  data() {
    return {
      addForm: {
        linkUrl: "",
        content: "",
        orderNum: "",
        picUrl: "",
        title: "",
        appId: "",
        url: "",
        msgType: "link",
        fileName: "",
      },
      Imgsize: 10,
    };
  },
  created() {
    // this.relaxWxConfig();
  },

  watch: {
    showPage(val) {
      if (val) {
        if (this.isEdit) {
          this.addForm = { ...this.ruleForm };
          //console.log(this.addForm)
        }
      }
    },
  },

  methods: {
    ensureComfirm() {
      let form = this.$refs.form;
      form
        .validate(["linkAdd", "linkTitle"])
        .then(() => {
          if (this.isEdit) {
            this.addForm.fileName = this.addForm.title;
            this.$emit("editFileUpload", this.addForm, this.index);
            Object.assign(this.$data, this.$options.data());
          } else {
            this.addForm.fileName = this.addForm.title;
            this.$emit("uploadInfo", this.addForm);
            Object.assign(this.$data, this.$options.data());
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    resetUser() {
      this.$emit("cancelBack");
    },

    resetTag(e) {
      let target = e.target;
      if (this.selectArr.join("")) {
        this.selectArr = [];
        target.classList.remove("resetTag");
      } else {
        this.$store.commit("selectTags", this.selectArr);
        this.$router.push("customerGroup");
      }
    },
    welcomeImg(obj) {
      console.log(obj);
      this.addForm.picUrl = obj.url;
    },
  },
};
</script>

<style scoped lang="less">
@import "css/min-wesite";
</style>
